import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import { LandingPage } from './pages/LandingPage';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { DashboardPage } from './pages/DashboardPage';
import { WorkspaceHubPage } from './pages/WorkspaceHubPage';
import { WorkspacePage } from './pages/WorkspacePage';
import { GeneratePage } from './pages/GeneratePage';
import { BrandProfilePage } from './pages/BrandProfilePage';
import { TemplatesPage } from './pages/TemplatesPage';
import { TemplateEditorPage } from './pages/TemplateEditorPage';
import { GalleryPage } from './pages/GalleryPage';

import { AdminPage } from './pages/AdminPage';
import { ModPage } from './pages/ModPage';
import { QuickGenPage } from './pages/QuickGenPage';
import { CalendarPage } from './pages/CalendarPage';
import { TeamPage } from './pages/TeamPage';
import { BillingPage } from './pages/BillingPage';
import CampaignManagerPage from './pages/CampaignManagerPage';
import CampaignDetailPage from './pages/CampaignDetailPage';
import { Layout } from './components/Layout';
import { WorkspaceProvider } from './providers/WorkspaceProvider';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return user ? <>{children}</> : <Navigate to="/" />;
}

function PublicRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return user ? <Navigate to="/dashboard" /> : <>{children}</>;
}

export function App() {
  return (
    <Routes>
      {/* Landing page for unauthenticated users */}
      <Route
        path="/"
        element={
          <PublicRoute>
            <LandingPage />
          </PublicRoute>
        }
      />
      <Route
        path="/login"
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }
      />
      <Route
        path="/register"
        element={
          <PublicRoute>
            <RegisterPage />
          </PublicRoute>
        }
      />
      {/* Authenticated app shell */}
      <Route
        element={
          <PrivateRoute>
            <WorkspaceProvider>
              <Layout />
            </WorkspaceProvider>
          </PrivateRoute>
        }
      >
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="admin" element={<AdminPage />} />
        <Route path="mod" element={<ModPage />} />
        <Route path="quickgen/:workspaceId" element={<QuickGenPage />} />
        <Route path="workspace/:workspaceId" element={<WorkspaceHubPage />} />
        <Route path="workspace/:workspaceId/setup" element={<WorkspacePage />} />
        <Route path="workspace/:workspaceId/brand-profile" element={<BrandProfilePage />} />
        <Route path="workspace/:workspaceId/generate" element={<GeneratePage />} />
        <Route path="workspace/:workspaceId/templates" element={<TemplatesPage />} />
        <Route path="workspace/:workspaceId/templates/:templateId" element={<TemplateEditorPage />} />
        <Route path="workspace/:workspaceId/gallery" element={<GalleryPage />} />
        <Route path="workspace/:workspaceId/calendar" element={<CalendarPage />} />
        <Route path="workspace/:workspaceId/team" element={<TeamPage />} />
        <Route path="campaigns" element={<CampaignManagerPage />} />
        <Route path="campaigns/:campaignId" element={<CampaignDetailPage />} />
        <Route path="billing" element={<BillingPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}
